import { render, staticRenderFns } from "./MerchantPage.vue?vue&type=template&id=2b71daf6&scoped=true&"
import script from "./MerchantPage.vue?vue&type=script&lang=js&"
export * from "./MerchantPage.vue?vue&type=script&lang=js&"
import style0 from "./MerchantPage.vue?vue&type=style&index=0&id=2b71daf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71daf6",
  null
  
)

export default component.exports